<ng-container *ngFor="let group of options">
  <div class="row" *ngIf="group.canDisplay(flattenedPermissions)">
    <div class="col-4 fw-bold">
      {{ group.title }}
    </div>
    <div class="col-4">
      <div class="row" *ngFor="let opt of group.permissions">
        <div class="col-12">
          <lib-checkbox
            *ngIf="opt.canDisplay(flattenedPermissions)"
            [id]="'chk' + opt.val"
            [ngModel]="opt.selected"
            [label]="opt.display"
            (ngModelChange)="valueChanged(opt.val, $event)"></lib-checkbox>
        </div>
      </div>
    </div>
  </div>
</ng-container>
